import {
  COUNTRY_CODE_OPTIONS,
  DEFAULT_COUNTRY_CODE,
  type CountryCodeOption,
} from "../constants/countryCodes";

const toDigits = (value: string): string => value.replace(/\D/g, "");

export const normalizePhoneForStorage = (
  rawInput: string,
  countryCode: string = DEFAULT_COUNTRY_CODE,
): string => {
  const trimmed = rawInput.trim();
  if (!trimmed) {
    return "";
  }

  if (trimmed.startsWith("+")) {
    const digits = toDigits(trimmed.slice(1));
    return digits ? `+${digits}` : "";
  }

  const digits = toDigits(trimmed).replace(/^0+/, "");
  return digits ? `${countryCode}${digits}` : "";
};

export const stripCountryCodeForDisplay = (
  value: string | null | undefined,
  countryCode: string = DEFAULT_COUNTRY_CODE,
): string => {
  if (!value) {
    return "";
  }

  if (value.startsWith(countryCode)) {
    return value.slice(countryCode.length);
  }

  return value;
};

export const formatPhoneBodyForDisplay = (
  value: string | null | undefined,
): string => {
  if (!value) {
    return "";
  }

  const digits = toDigits(value);
  if (!digits) {
    return "";
  }

  return digits.match(/.{1,3}/g)?.join(" ") || digits;
};

export const detectPhoneCountryCode = (
  value: string | null | undefined,
  options: CountryCodeOption[] = COUNTRY_CODE_OPTIONS,
  fallback: string = DEFAULT_COUNTRY_CODE,
): string => {
  if (!value || !value.startsWith("+")) {
    return fallback;
  }

  const sorted = [...options].sort((a, b) => b.code.length - a.code.length);
  const matched = sorted.find((option) => value.startsWith(option.code));
  return matched?.code ?? fallback;
};
